// Single source of truth for external links
export const FRESHA_BOOKING_URL =
  "https://www.fresha.com/de/a/urban-beauty-klosters-klosters-serneus-landstrasse-206-bip3mmnv";

// Google review link – opens the business listing (via stable CID) where the customer can leave a review.
export const GOOGLE_REVIEW_URL =
  "https://www.google.com/maps?cid=12330107603577212010";
